$(function(){
  // 「カートに追加」の前に `#total_print` を追加
  $('#abi_cart_btn').before('<div id="total_print">合計: <span></span></div>');
  changePrice();
  // 「合計」の前に `.bold_option_total` を追加
  $('#total_print').before('<div id="bold_option_total" class="bold_option_hidden">追加料金: <span></span></div>');
  changePrice();

    // formに対してイベントを追加product_form_
    $('form[id^="product-form-template--"]').change(function(){
      // radiobutton処理に対して追加金額が即時反映されないので、ワンテンポ遅らせる
      setTimeout(function(){
        changePrice()
      }, 200)
    })

    // オブザーバーの作成
    const observer_money_price = new MutationObserver(function() {
      changePrice();
    });

    // オブザーバーの開始
    observer_money_price.observe(
      document.getElementById('money_price'),
      {
        childList: true,
        subtree: true
      }
    );

    // フォームサブミット（カート追加）時の処理
    $('form[id^="product-form-template--"] :button').on('click', function() {
      if (validateFormAndAddOptions()) {
        // フォーム送信
        return true;
      } else {
        // フォーム送信キャンセル
        return false;
      }
    });
});// end BOLD.options.app.on

function validateFormAndAddOptions() {
  console.log('validateFormAndAddOptions');
  let option_error = false;
  let option_add_error = false;
  let return_anchor = false;
  const errorIcon = '<span role="img" aria-label="⚠" style="font-family:&quot;Apple Color Emoji&quot;,&quot;Segoe UI Emoji&quot;,NotoColorEmoji,&quot;Noto Color Emoji&quot;,&quot;Segoe UI Symbol&quot;,&quot;Android Emoji&quot;,EmojiSymbols;line-height:1em;white-space:nowrap;font-size:1em">⚠</span> ';
  const errorMessages = {
    'model'                : errorIcon + '機種を選択してください',
    'alphabet'             : errorIcon + 'アルファベットを選択してください',
    'bookTitle'            : errorIcon + '本のタイトルを入力してください',
    'authorName'           : errorIcon + '著者名を入力してください',
    'twitterIdSelection'   : errorIcon + 'X（旧Twitter）IDがある方を選択してください',
    'twitterId'            : errorIcon + 'あなたのX（旧Twitter）ID を入力してください',
    'nameEngraving'        : errorIcon + '名入れ文字を入力してください',
    'nameEngravingDesire'  : errorIcon + '名入れの希望を選択してください',
    'nameEngravingText'    : errorIcon + '名入れ文字を入力してください',
    'nameEngravingOver'    : errorIcon + '名入れ文字数がオーバーしています',
    'nameEngravingPosition': errorIcon + '名入れ位置を選択してください',
    'handStrapColor'       : errorIcon + 'ハンドストラップのカラーを選択してください',
    'toteStrapColor'       : errorIcon + '手提げストラップのカラーを選択してください',
    'loopStrapColor'       : errorIcon + 'ループストラップのカラーを選択してください',
    'hmStrapColor'       : errorIcon + 'HMストラップのカラーを選択してください',
    'shoulderStrapColor'   : errorIcon + 'ショルダーストラップのカラーを選択してください',
    'strapHoleSelection'   : errorIcon + 'ストラップ穴を選択してください',
    'strapHoleError'       : errorIcon + '手提げストラップ、ショルダーストラップはケースの上下に穴をあけるを選択してください',
    'strapChoiceError'     : errorIcon + 'ストラップを選択してください',
    'initalSizeError'     : errorIcon + 'イニシャルのサイズを選択してください',
    'initalTypeError'     : errorIcon + 'イニシャルのタイプを選択してください'
  };


  var $form = $('form[id^="product-form-template--"]');
  // POSTされる値を取得
  var param = $form.serializeArray();

  // 一旦エラーメッセージを非表示
  $('form[id^="product-form-template--"]').find('.bold_error_message').addClass('bold_option_hidden');
  $('form[id^="product-form-template--"]').find('.bold_option_title').removeClass('bold_option_error');

  // ビジネス会員 手帳型サイズあり EXC2HNJ2A-DAN-WH のバリデーション
  if ($('#product-option-1').length) {
    if ( !$('#product-option-1-001 option:selected').val() && !$('#product-option-1-002 option:selected').val() && !$('#product-option-1-003 option:selected').val() && !$('#product-option-1-004 option:selected').val() && !$('#product-option-1-005 option:selected').val() && !$('#product-option-1-006 option:selected').val() && !$('#product-option-1-007 option:selected').val() && !$('#product-option-1-008 option:selected').val() && !$('#product-option-1-009 option:selected').val() && !$('#product-option-1-010 option:selected').val() && !$('#product-option-1-011 option:selected').val() && !$('#product-option-1-012 option:selected').val() && !$('#product-option-1-013 option:selected').val() && !$('#product-option-1-014 option:selected').val() && !$('#product-option-1-015 option:selected').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-1';
      }
      $('#product-option-1').find('.bold_option_title').addClass('bold_option_error');
      $('#product-option-1-001 > label > .bold_option_title').before('<span class="bold_error_message">' + errorMessages.model + '</span>');
    }
  }

  // ビジネス会員限定 クリアケース ハードタイプ SOHCOTG3-CL のバリデーション
  if ($('#product-option-2').length) {
    if ( !$('#product-option-2-001 option:selected').val() && !$('#product-option-2-002 option:selected').val() && !$('#product-option-2-003 option:selected').val() && !$('#product-option-2-004 option:selected').val() && !$('#product-option-2-005 option:selected').val() && !$('#product-option-2-006 option:selected').val() && !$('#product-option-2-007 option:selected').val() && !$('#product-option-2-008 option:selected').val() && !$('#product-option-2-009 option:selected').val() && !$('#product-option-2-010 option:selected').val() && !$('#product-option-2-011 option:selected').val() && !$('#product-option-2-012 option:selected').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-2';
      }
      $('#product-option-2').find('.bold_option_title').addClass('bold_option_error');
      $('#product-option-2-001 > label > .bold_option_title').before('<span class="bold_error_message">' + errorMessages.model + '</span>');
    }
  }

  // ビジネス会員限定 レザータイプ 手帳型ケース EXC2HN1A-DAN のバリデーション
  if ($('#product-option-3').length) {
    if ( !$('#product-option-3-001 option:selected').val() && !$('#product-option-3-002 option:selected').val() && !$('#product-option-3-003 option:selected').val() && !$('#product-option-3-004 option:selected').val() && !$('#product-option-3-005 option:selected').val() && !$('#product-option-3-006 option:selected').val() && !$('#product-option-3-007 option:selected').val() && !$('#product-option-3-008 option:selected').val() && !$('#product-option-3-009 option:selected').val() && !$('#product-option-3-010 option:selected').val() && !$('#product-option-3-011 option:selected').val() && !$('#product-option-3-012 option:selected').val() && !$('#product-option-3-013 option:selected').val() && !$('#product-option-3-014 option:selected').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-3';
      }
      $('#product-option-3').find('.bold_option_title').addClass('bold_option_error');
      $('#product-option-3-001 > label > .bold_option_title').before('<span class="bold_error_message">' + errorMessages.model + '</span>');
    }
  }

  // アルファベットの選択のバリデーション(くすみイニシャル)
  if (!myHandle.startsWith('exc2hns3') && $('#product-option-4').length) {
    
    let sel_variant = document.querySelector("input[name='イニシャル']:checked");
    // アルファベットの選択のバリデーション
    if ((sel_variant === null || !sel_variant.value.includes('なし')) && !$('#product-option-4-001 option:selected').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-4-001';
      }
      $('#product-option-4-001 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-4-001 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.alphabet + '</span>');
    } else if(sel_variant !== null && sel_variant.value.includes('なし')) {
      $('#product-option-4-001 select').prop('disabled', true);
    }
  }
  // アルファベットの選択のバリデーション(exc2hns3)
  if (myHandle.startsWith('exc2hns3') && $('#product-option-4').length) {
    const initialRadios = document.getElementsByName('イニシャル');
    let selectedInitialValue = null;
    for (const radio of initialRadios) {
        if (radio.checked) {
            selectedInitialValue = radio.value;
            break;
        }
    }
    // アルファベットの選択のバリデーション（イニシャル「なし」以外のケースで実行）
    if ( !$('#product-option-4-001 option:selected').val() && !selectedInitialValue.includes('なし') ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-4-001';
      }
      $('#product-option-4-001 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-4-001 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.alphabet + '</span>');
    }
  }

  // アルファベットの選択のバリデーション(イニシャルプラスシンプル)
  if ($('#product-option-6').length) {
    // アルファベットの選択のバリデーション
    if ( !$('#product-option-6-003 option:selected').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-6-003';
      }
      $('#product-option-6-003 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-6-003 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.alphabet + '</span>');
    }
  }

  // アルファベットの選択のバリデーション(イニシャルプラスデコ)
  if ($('#product-option-7').length) {
    // アルファベットの選択のバリデーション
    if ( !$('#product-option-7-003 option:selected').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-7-003';
      }
      $('#product-option-7-003 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-7-003 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.alphabet + '</span>');
    }
  }

  // 本のスマホケースのバリデーション
  if ($('#product-option-8').length) {
    // 本のタイトル
    if ( !$('#product-option-8-001 input[name="properties[本のタイトル1行目]"]').val().length ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-8-001';
      }
      $('#product-option-8-001 > span.bold_option_title').addClass('bold_option_error');
      $('#title_restrict').after('<span class="bold_error_message">' + errorMessages.bookTitle + '</span>');
    }

    // 著者名
    if ( !$('#product-option-8-002 input[name="properties[著者名]"]').val().length ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-8-002';
      }
      $('#product-option-8-002 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-8-002 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.authorName + '</span>');
    }

    // Twitter IDがある方のバリデーション
    if ( !$('#product-option-8-003 option:selected').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-8-003';
      }
      $('#product-option-8-003 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-8-003 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.twitterIdSelection + '</span>');
    }

    // あなたのTwitter IDのバリデーション
    if ( $('#product-option-8-003 option:selected').val() == 'Twitterプロフィール追加' && !$('#product-option-8-004 input[name="properties[あなたのTwitter ID]"]').val().length ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-8-004';
      }
      $('#product-option-8-004 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-8-004 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.twitterId + '</span>');
    }
  }

  // 名入れ文字のバリデーション
  if ($('#product-option-9').length) {
    // 著者名
    if ( !$('#product-option-9-001 input[name="properties[名入れ文字]"]').val().length ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-9-001';
      }
      $('#product-option-9-001 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-9-001 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.nameEngraving + '</span>');
    }
  }

  // べっ甲風名入れの選択のバリデーション
  if ($('#product-option-10').length) {
    // 名入れの希望のバリデーション
    if ( !$('#product-option-10-001 option:selected').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-10-001';
      }
      $('#product-option-10-001 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-10-001 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.nameEngravingDesire + '</span>');
    }

    // 名入れ文字のバリデーション
    if ($('#product-option-10-001 option:selected').val() == '名入れを希望する') {
      if ($('#product-option-10-002 input[name="_count[名入れ文字]"]').val() == 0) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-10-002';
        }
        $('#product-option-10-002 > label > .bold_option_title').addClass('bold_option_error');
        $('#product-option-10-002 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.nameEngravingText + '</span>');
      }
      if ($('#product-option-10-002 input[name="_count[名入れ文字]"]').val() > 12) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-10-002';
        }
        $('#product-option-10-002 > label > .bold_option_title').addClass('bold_option_error');
        $('#product-option-10-002 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.nameEngravingOver + '</span>');
      }
    }
  }

  // 名入れ レザーハイクラス 手帳型ケースのバリデーション
  if ($('#product-option-11').length) {
    // 名入れ文字のバリデーション
    if ($('#product-option-11-004 input[name="_count[名入れ文字]"]').val() == 0) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-11-004';
      }
      $('#product-option-11-004 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-11-004 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.nameEngravingText + '</span>');
    }
    if ($('#product-option-11-004 input[name="_count[名入れ文字]"]').val() > 12) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-11-004';
      }
      $('#product-option-11-004 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-11-004 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.nameEngravingOver + '</span>');
    }

    // 名入れ位置のバリデーション
    if ( !$('#product-option-11-005 option:selected').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-11-005';
      }
      $('#product-option-11-005 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-11-005 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.nameEngravingPosition + '</span>');
    }
  }

  // イタリアンレザーのストラップのバリデーション
  if ($('#product-option-12-001').length) {
    // ハンドストラップ
    if ( $('#product-option-12-002 input[name="properties[_ハンドストラップ]"]').val() == 'ハンドストラップ' && !$('#product-option-12-003-select input[name="properties[_ハンドストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-12-003-select';
        }
        $('#product-option-12-003-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-12-003-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.handStrapColor + '</span>');
    }

    // 手提げストラップ
    if ( $('#product-option-12-013 input[name="properties[_手提げストラップ]"]').val() == '手提げストラップ' && !$('#product-option-12-014-select input[name="properties[_手提げストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-12-014-select';
        }
        $('#product-option-12-014-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-12-014-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.toteStrapColor + '</span>');
    }

    // ショルダーストラップ
    if ( $('#product-option-12-024 input[name="properties[_ショルダーストラップ]"]').val() == 'ショルダーストラップ' && !$('#product-option-12-025-select input[name="properties[_ショルダーストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-12-025-select';
        }
        $('#product-option-12-025-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-12-025-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.shoulderStrapColor + '</span>');
    }

   //ストラップ穴
   let my_handStrap = $('#product-option-12-002 input[name="properties[_ハンドストラップ]"]').val();
   let my_tesageStrap = $('#product-option-12-013 input[name="properties[_手提げストラップ]"]').val();
   let my_shoulderStrap = $('#product-option-12-024 input[name="properties[_ショルダーストラップ]"]').val();
   let check_Strap = true;
   let msg_strap_error = '';
   if ((my_handStrap != 'なし' || my_tesageStrap != 'なし' || my_shoulderStrap != 'なし')  && $('#product-option-12-035 option:selected').val() === 'なし' ) {
      //どれかのストラップを選択　かつ　ストラップ穴の選択なし
      check_Strap = false;
      msg_strap_error = errorMessages.strapHoleSelection;
    } else {
      //手提げストラップもしくはショルダーストラップを選択　かつ　ストラップ穴が上部のみか下部のみ
      let my_strapHole = $('#product-option-12-035 option:selected').val();
      if((my_tesageStrap != 'なし' || my_shoulderStrap != 'なし') && (my_strapHole == 'ケースの上部にあける' || my_strapHole == 'ケースの下部にあける')){
        check_Strap = false;
        msg_strap_error = errorMessages.strapHoleError;
      }
    }

    if(!check_Strap){
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-12-035-select';
      }
      $('#product-option-12-035-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
      $('#product-option-12-035-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + msg_strap_error + '</span>');
    }
  }

  // 栃木レザーのストラップのバリデーション
  if ($('#product-option-14-001').length) {
    // ハンドストラップ
    if ( $('#product-option-14-002 input[name="properties[_ハンドストラップ]"]').val() == 'ハンドストラップ' && !$('#product-option-14-003-select input[name="properties[_ハンドストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-14-003-select';
        }
        $('#product-option-14-003-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-14-003-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.handStrapColor + '</span>');
    }


    // 手提げストラップ
    if ( $('#product-option-14-010 input[name="properties[_手提げストラップ]"]').val() == '手提げストラップ' && !$('#product-option-14-011-select input[name="properties[_手提げストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-14-011-select';
        }
        $('#product-option-14-011-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-14-011-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.toteStrapColor + '</span>');
    }


    // ショルダーストラップ
    if ( $('#product-option-14-018 input[name="properties[_ショルダーストラップ]"]').val() == 'ショルダーストラップ' && !$('#product-option-14-019-select input[name="properties[_ショルダーストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-14-019-select';
        }
        $('#product-option-14-019-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-14-019-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.shoulderStrapColor + '</span>');
    }
   //ストラップ穴
   let my_handStrap = $('#product-option-14-002 input[name="properties[_ハンドストラップ]"]').val();
   let my_tesageStrap = $('#product-option-14-010 input[name="properties[_手提げストラップ]"]').val();
   let my_shoulderStrap = $('#product-option-14-018 input[name="properties[_ショルダーストラップ]"]').val();
   let check_Strap = true;
   let msg_strap_error = '';
   if ((my_handStrap != 'なし' || my_tesageStrap != 'なし' || my_shoulderStrap != 'なし')  && $('#product-option-14-026 option:selected').val() === 'なし' ) {
      //どれかのストラップを選択　かつ　ストラップ穴の選択なし
      check_Strap = false;
      msg_strap_error = errorMessages.strapHoleSelection;
    } else {
      //手提げストラップもしくはショルダーストラップを選択　かつ　ストラップ穴が上部のみか下部のみ
      let my_strapHole = $('#product-option-14-026 option:selected').val();
      if((my_tesageStrap != 'なし' || my_shoulderStrap != 'なし') && (my_strapHole == 'ケースの上部にあける' || my_strapHole == 'ケースの下部にあける')){
        check_Strap = false;
        msg_strap_error = errorMessages.strapHoleError;
      }
    }

    if(!check_Strap){
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-14-026-select';
      }
      $('#product-option-14-026-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
      $('#product-option-14-026-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + msg_strap_error + '</span>');
    }

  }

  // 姫路レザーのストラップのバリデーション
  if ($('#product-option-15-001').length) {
    const no_hole_collection_id ='298345955534';
    let no_strap_hole = false;
    if(CollectionIds.includes(no_hole_collection_id)){ //CollectionIds @see sectios/main-product.liquid
      no_strap_hole = true;
    }
    // ハンドストラップ
    if ( $('#product-option-15-002 input[name="properties[_ハンドストラップ]"]').val() == 'ハンドストラップ' && !$('#product-option-15-003-select input[name="properties[_ハンドストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-15-003-select';
        }
        $('#product-option-15-003-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-15-003-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.handStrapColor + '</span>');
    }

    // ハンドストラップ穴
    if ( $('#product-option-15-002 input[name="properties[_ハンドストラップ]"]').val() == 'ハンドストラップ' && !$('#product-option-15-011 option:selected').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-15-010';
        }
        $('#product-option-15-003-select').find('.bold_option_title').eq(1).addClass('bold_option_error');
        $('#product-option-15-003-select').find('.bold_option_title').eq(1).after('<span class="bold_error_message">' + errorMessages.strapHoleSelection + '</span>');
    }

    // 手提げストラップ
    if ( $('#product-option-15-012 input[name="properties[_手提げストラップ]"]').val() == '手提げストラップ' && !$('#product-option-15-013-select input[name="properties[_手提げストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-15-013-select';
        }
        $('#product-option-15-013-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-15-013-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.toteStrapColor + '</span>');
    }

    // 手提げストラップ穴
    if ( $('#product-option-15-012 input[name="properties[_手提げストラップ]"]').val() == '手提げストラップ' && !$('#product-option-15-021 option:selected').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-15-020';
        }
        $('#product-option-15-013-select').find('.bold_option_title').eq(1).addClass('bold_option_error');
        $('#product-option-15-013-select').find('.bold_option_title').eq(1).after('<span class="bold_error_message">' + errorMessages.strapHoleSelection + '</span>');
    }

    // ショルダーストラップ
    if ( $('#product-option-15-022 input[name="properties[_ショルダーストラップ]"]').val() == 'ショルダーストラップ' && !$('#product-option-15-023-select input[name="properties[_ショルダーストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-15-023-select';
        }
        $('#product-option-15-023-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-15-023-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.shoulderStrapColor + '</span>');
    }

    // ショルダーストラップ穴
    if ( $('#product-option-15-022 input[name="properties[_ショルダーストラップ]"]').val() == 'ショルダーストラップ' && !$('#product-option-15-031 option:selected').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-15-031';
        }
        $('#product-option-15-023-select').find('.bold_option_title').eq(1).addClass('bold_option_error');
        $('#product-option-15-023-select').find('.bold_option_title').eq(1).after('<span class="bold_error_message">' + errorMessages.strapHoleSelection + '</span>');
    }

    if(no_strap_hole){
      $('#product-option-15-003-select select[name="properties[ハンドストラップを付ける穴]"]').prop('disabled', true);
      $('#product-option-15-013-select select[name="properties[手提げストラップを付ける穴]"]').prop('disabled', true);
      $('#product-option-15-023-select select[name="properties[ショルダーストラップを付ける穴]"]').prop('disabled', true);
    }
  }

  // 合皮ストラップのバリデーション
  if ($('#product-option-16-001').length) {
    // 手提げストラップ
    if ( $('#product-option-16-002 input[name="properties[_手提げストラップ]"]').val() == '手提げストラップ' && !$('#product-option-16-003-select input[name="properties[_手提げストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-16-003-select';
        }
        $('#product-option-16-003-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-16-003-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.toteStrapColor + '</span>');
    }

    // ショルダーストラップ
    if ( $('#product-option-16-013 input[name="properties[_ショルダーストラップ]"]').val() == 'ショルダーストラップ' && !$('#product-option-16-014-select input[name="properties[_ショルダーストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-16-014-select';
        }
        $('#product-option-16-014-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-16-014-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.shoulderStrapColor + '</span>');
    }
  }

    // 名入れ文字のバリデーション
  if ($('#product-option-19').length) {
    // 著者名
    if ( !$('#product-option-19-001 input[name="properties[名入れ文字]"]').val().length ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-19-001';
      }
      $('#product-option-19-001 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-19-001 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.nameEngraving + '</span>');
    }
  }

  // 絵本のスマホケースのバリデーション
  if ($('#product-option-21').length) {
    // 本のタイトル
    if ( !$('#product-option-21-001 input[name="properties[本のタイトル1行目]"]').val().length ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-21-001';
      }
      $('#product-option-21-001 > span.bold_option_title').addClass('bold_option_error');
      $('#title_restrict').after('<span class="bold_error_message">' + errorMessages.bookTitle + '</span>');
    }

    // 著者名
    if ( !$('#product-option-21-002 input[name="properties[著者名]"]').val().length ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-21-002';
      }
      $('#product-option-21-002 > label > .bold_option_title').addClass('bold_option_error');
      $('#product-option-21-002 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.authorName + '</span>');
    }

  }
    
  // シュリンク姫路レザーのストラップのバリデーション
  if ($('#product-option-23-001').length) {
    // ループストラップ
    if ( $('#product-option-23-002 input[name="properties[_ループストラップ]"]').val() == 'ループストラップ' && !$('#product-option-23-003-select input[name="properties[_ループストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-23-003-select';
        }
        $('#product-option-23-003-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-23-003-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.loopStrapColor + '</span>');
    }

    // ショルダーストラップ
    if ( $('#product-option-23-011 input[name="properties[_ショルダーストラップ]"]').val() == 'ショルダーストラップ' && !$('#product-option-23-012-select input[name="properties[_ショルダーストラップのカラー]"]').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-23-012-select';
        }
        $('#product-option-23-012-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-23-012-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.shoulderStrapColor + '</span>');
    }

  }

  // HMストラップのバリデーション
  if ($('#product-option-24-001').length) {
    if ( $('#product-option-24-002 input[name="properties[_HMストラップ]"]').val() == 'HMストラップ' && !$('#product-option-24-003-select input[name="properties[_HMストラップのカラー]"]').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-24-003-select';
      }
      $('#product-option-24-003-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
      $('#product-option-24-003-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.hmStrapColor + '</span>');
    }

  }

  //ちょいまる 透明クリアケースとのセット
  if ($('#product-option-25').length) {
    let check_strap = document.querySelector("input[name='ストラップ留め']:checked");
    if ( check_strap.value != 'ストラップ留めなし' && !$('#product-option-25 input[name="properties[bundle_variant_id][ストラップ]"]').val() ) {
      option_error = true;
      if (!return_anchor) {
          return_anchor = '#product-option-25';
      }
      $('#product-option-25').find('.bold_option_title').eq(0).addClass('bold_option_error');
      $('#product-option-25').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.strapChoiceError + '</span>');
    }
  }

  //EXC2HC09A クリアケース 名入れ
  if ($('#product-option-26').length) {
    let sel_variant = document.querySelector("input[name='名入れ']:checked");
    if(sel_variant.value != '名入れなし' && sel_variant.value != 'なし'){
      if ( !$('#product-option-26-001 input[name="properties[名入れ文字]"]').val().length ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-26-001';
        }
        $('#product-option-26-001 > label > .bold_option_title').addClass('bold_option_error');
        $('#product-option-26-001 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.nameEngraving + '</span>');
      }
    }

  }
    
  //名入れ ステンレス ストラップホルダー
  if ($('#product-option-27-001').length) {
      if ( $('#product-option-27-003 input[name="properties[_HMストラップ]"]').val() == 'HMストラップ' && !$('#product-option-27-004-select input[name="properties[_HMストラップのカラー]"]').val() ) {
          option_error = true;
          if (!return_anchor) {
              return_anchor = '#product-option-27-004-select';
          }
          $('#product-option-27-004-select').find('.bold_option_title').eq(0).addClass('bold_option_error');
          $('#product-option-27-004-select').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.hmStrapColor + '</span>');
      }

      if ( !$('#product-option-27-001-input input[name="properties[名入れ文字]"]').val().length ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-27-001-input';
        }
        $('#product-option-27-001-input').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-27-001-input').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.nameEngraving + '</span>');
      }
  }

  if ($('#product-option-28').length) {
    if ( $('#product-option-28-001 input[name="properties[_名入れ]"]').val() != 'なし'){
      if ( !$('#product-option-28 input[name="properties[名入れ文字]"]').val().length ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-28-001-input';
        }
        $('#product-option-28-001-input').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-28-001-input').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.nameEngraving + '</span>');
      }
    }
  }

  //レザーシンプル 手帳型ケース イニシャルプラス
  if ($('#product-option-29').length) {
    let sel_variant = document.querySelector("input[name='イニシャル']:checked");
    let myMSG = null;
    if(sel_variant.value == 'イニシャルプラスデコ'){
      //console.log('サイズ:' + $('#product-option-29-001 input[name="properties[イニシャルのサイズ]"]').val());
      //console.log('文字:' + $('#product-option-29-005 option:selected').val());
      if ( $('#product-option-29-001 input[name="properties[イニシャルのサイズ]"]').val() == '') {
        return_anchor = '#initial_deco';
        myMSG = errorMessages.initalSizeError;
      } else if ( !$('#product-option-29-005 option:selected').val() ) {
        return_anchor = '#product-option-29-005';
        myMSG = errorMessages.alphabet;
      }
    } else if(sel_variant.value == 'イニシャルプラスシンプル'){
      if ( $('#product-option-29-003 input[name="properties[イニシャルのタイプ]"]').val() == '') {
        return_anchor = '#initial_simple';
        myMSG = errorMessages.initalTypeError;
      } else if ( !$('#product-option-29-005 option:selected').val() ) {
        return_anchor = '#product-option-29-005';
        myMSG = errorMessages.alphabet;
      }
    }

    if (myMSG !== null) {
      option_error = true;
      if(return_anchor == '#initial_deco'){
        $('#initial_deco > .bold_option_swatch > .bold_option_title').addClass('bold_option_error');
        $('#initial_deco > .bold_option_swatch > .bold_option_title').after('<span class="bold_error_message">' + myMSG + '</span>');
      } else if(return_anchor == '#initial_simple'){
        $('#initial_simple > .bold_option_swatch > .bold_option_title').addClass('bold_option_error');
        $('#initial_simple > .bold_option_swatch > .bold_option_title').after('<span class="bold_error_message">' + myMSG + '</span>');
      } else {
        $(return_anchor + ' > label > .bold_option_title').addClass('bold_option_error');
        $(return_anchor + ' > label > .bold_option_title').after('<span class="bold_error_message">' + myMSG + '</span>');
      }
    } else {
      //仕掛かり中の他の選択値を初期化して送信しない
      if(sel_variant.value == 'イニシャルプラスデコ'){
        $('#initial_simple input[name="properties[イニシャルのタイプ]"]').val('');
        $('#initial_simple input[name="properties[イニシャルのタイプ]"]').prop('disabled', true);
      } else if(sel_variant.value == 'イニシャルプラスシンプル'){
        $('#initial_deco input[name="properties[イニシャルのサイズ]"]').val('');
        $('#initial_deco input[name="properties[イニシャルのサイズ]"]').prop('disabled', true);
      } else {
        $('#initial_simple input[name="properties[イニシャルのタイプ]"]').val('');
        $('#initial_simple input[name="properties[イニシャルのタイプ]"]').prop('disabled', true);
        $('#initial_deco input[name="properties[イニシャルのサイズ]"]').val('');
        $('#initial_deco input[name="properties[イニシャルのサイズ]"]').prop('disabled', true);
        $('#product-option-29-005 select').val("");
        $('#product-option-29-005 select').prop('disabled', true);
      }
    }
  }

  if ($('#product-option-30').length) {
    let sel_variant = document.querySelector("input[name='ポーチサイズ']:checked");
    //関係のないオプションは送信しない
    if(sel_variant.value.includes('名入れ')){
      if ( !$('#product-option-30 input[name="properties[名入れ文字]"]').val().length ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-30-001-input';
        }
        $('#product-option-30-001-input').find('.bold_option_title').eq(0).addClass('bold_option_error');
        $('#product-option-30-001-input').find('.bold_option_title').eq(0).after('<span class="bold_error_message">' + errorMessages.nameEngraving + '</span>');
      }
    } else {
      $('#product-option-30 input[name="properties[名入れ文字]"]').val('');
      $('#product-option-30 input[name="properties[名入れ文字]"]').prop('disabled', true);
    }
  }

  if ($('#product-option-31').length) { //本のスマホケース（タイトル変更あり、なし）
    let sel_variant = document.querySelector("input[name='タイトルの変更']:checked");
    sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));
    console.log(sel_variant.value);
    //使っていないoption-5
    $('#product-option-5-001 input[name="properties[イメージ画像]"]').prop('disabled', true);
    $('#product-option-5-001 input[name="properties[表側デザインファイル]"]').prop('disabled', true);
    $('#product-option-5-001 input[name="properties[裏側デザインファイル]"]').prop('disabled', true);
    if(sel_variant.value == 'タイトル変更なし'){
      $('#product-option-31-001 input[name="properties[本のタイトル1行目]"]').prop('disabled', true);
      $('#product-option-31-001 input[name="properties[本のタイトル2行目]"]').prop('disabled', true);
      $('#product-option-31-001 input[name="properties[本のタイトル3行目]"]').prop('disabled', true);
      $('#product-option-31-001 textarea[name="properties[背表紙]"]').prop('disabled', true);
      $('#product-option-31-002 input[name="properties[著者名]"]').prop('disabled', true);
      $('#product-option-31-003 select').prop('disabled', true);
      $('#product-option-31-004 input[name="properties[X ID]"]').prop('disabled', true);
      $('#product-option-31-004 input[name="properties[bundle_variant_id][X IDがある方]"]').prop('disabled', true);
    } else {
      // 本のタイトル
      if ( !$('#product-option-31-001 input[name="properties[本のタイトル1行目]"]').val().length ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-31-001';
        }
        $('#product-option-31-001 > span.bold_option_title').addClass('bold_option_error');
        $('#title_restrict').after('<span class="bold_error_message">' + errorMessages.bookTitle + '</span>');
      }

      // 著者名
      if ( !$('#product-option-31-002 input[name="properties[著者名]"]').val().length ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-31-002';
        }
        $('#product-option-31-002 > label > .bold_option_title').addClass('bold_option_error');
        $('#product-option-31-002 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.authorName + '</span>');
      }

      // X IDがある方のバリデーション
      if ( !$('#product-option-31-003 option:selected').val() ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-31-003';
        }
        $('#product-option-31-003 > label > .bold_option_title').addClass('bold_option_error');
        $('#product-option-31-003 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.twitterIdSelection + '</span>');
      }

      // X IDのバリデーション
      if ( $('#product-option-31-003 option:selected').val() == 'Xプロフィール追加' && !$('#product-option-31-004 input[name="properties[あなたのX ID]"]').val().length ) {
        option_error = true;
        if (!return_anchor) {
            return_anchor = '#product-option-31-004';
        }
        $('#product-option-31-004 > label > .bold_option_title').addClass('bold_option_error');
        $('#product-option-31-004 > label > .bold_option_title').after('<span class="bold_error_message">' + errorMessages.twitterId + '</span>');
      }     
    }
  }
  // console.log('option_error = ' + option_error);
  // console.log('return_anchor = ' + return_anchor);

  if(option_error) {
      // 送信しない
      $('html,body').animate({
        // 84 = headerの高さ
        scrollTop : $(return_anchor).offset().top - 84
      }, 'fast');
      return false;
  } else {
      // console.log('param = ');
      // console.log(param);
      // オプション商品を先にカートに追加
      var addItem = [];
      $.each(param, function(index, val){
          // console.log(val.name + ':' + val.value);
          if(val.name.match(/^properties\[bundle_variant_id\]/)){
              var formData = {
                  items: [
                      {
                          id: val.value,
                          quantity: 1
                      }
                  ]
              };

              var result = 'items' in JSON.parse(addCartOptionProduct(formData));
              if (result) {
                  addItem.push(val.value);
              } else {
                  option_add_error = true;
                  return false;
              }
          }
      });

      // 一旦エラーメッセージを非表示
      $('form[id^="product-form-template--"]').find('.bold_error_message').addClass('bold_option_hidden');
      $('form[id^="product-form-template--"]').find('.bold_option_title').removeClass('bold_option_error');

      // 追加エラーのあった場合は一旦追加文を削除
      if (option_add_error) {
          for ( let key in addItem ) {
              var formData = {
                  id: addItem[key],
                  quantity: 0
              };
              deleteCartOptionProduct(formData);
          }
          // 送信しない
          alert('商品をカートに追加できませんでした');
          return false;
      } else {
          // 送信
          return true;
      }
  };
}

function changePrice() {
   // 商品価格   {{ product.price | divided_by: 100.00 }}
   // オプション価格 $('#bold_option_total > span').html().replace(/\D/g, '')
    // 合計
    console.log('change price start');
    let sel_variant_price = 0;
    if ($('#product-option-23-001').length) { //シュリンク姫路レザーのストラップとのセット
      let sel_variant = document.querySelector("input[name='縦下げパーツ']:checked");
      sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));
    } else if ($('#product-option-24-001').length) { //HMストラップとのセット
      let sel_variant = document.querySelector("input[name='縦下げパーツ']:checked");
      sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));
    }  else if ($('#product-option-25').length) { //ちょいまる 透明クリアケースとのセット
      let sel_variant = document.querySelector("input[name='ストラップ留め']:checked");
      sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));
      if(sel_variant.value == 'ストラップ留めなし'){
          // オプション価格の合計の計算とオプションのフォームを無効
          if ($('#product-option-25 input[name="properties[_ストラップの価格]"]').val()) {
            let current_option_price = Number($('#product-option-25 input[name="properties[_ストラップの価格]"]').val());
            if(current_option_price > 0 ){
              let option_total_price = Number($('#bold_option_total > span').text().replace(/\D/g, ''));
              option_total_price = option_total_price - current_option_price;
              if (option_total_price > 0) {
                // オプション合計表示
                $('#bold_option_total > span').html('¥' + option_total_price.toLocaleString());
                $('#bold_option_total').removeClass('bold_option_hidden');
              } else {
                // 非表示
                $('#bold_option_total').addClass('bold_option_hidden');
                $('#bold_option_total > span').html('');
              }
            }
          }
          $('#product-option-25 input[name="properties[_ストラップの価格]"]').val('');
          $('#product-option-25 input[name="properties[_ストラップの価格]"]').prop('disabled', true);
          $('#product-option-25 input[name="properties[bundle_variant_id][ストラップ]"]').val('');
          $('#product-option-25 input[name="properties[bundle_variant_id][ストラップ]"]').prop('disabled', true);
          $('#product-option-25 span.bold_option_value_element').removeClass('bold_swatch_selected').next('.bold_option_swatch_title').removeClass('bold_option_selected');
      }
    }  else if ($('#product-option-26').length) { //EXC2HC09A クリアケース 名入れ
      let sel_variant = document.querySelector("input[name='名入れ']:checked");
      sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));
      if(sel_variant.value == '名入れなし' || sel_variant.value == 'なし'){
        $('#product-option-26 input[name="properties[名入れ文字]"]').val('');
        $('#product-option-26').fadeOut();
      } else {
        $('#product-option-26').fadeIn();
      }
        
    } else if ($('#product-option-28').length) { 
      let sel_variant = document.querySelector("input[name='サイズ']:checked");
      sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));

    } else if ($('#product-option-29').length) { //レザーシンプル 手帳型ケース イニシャルプラス
      //関係のないオプションは送信しない
      let sel_variant = document.querySelector("input[name='イニシャル']:checked");
      sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));
      if(sel_variant.value == 'イニシャルプラスデコ'){
        $('#initial_deco').css('display','block');
        $('#initial_deco input[name="properties[イニシャルのサイズ]"]').prop('disabled', false);
        $('#initial_simple').css('display','none');
        $('#initial_alphabet').css('display','block');
        $('#product-option-29').fadeIn();   
      } else if(sel_variant.value == 'イニシャルプラスシンプル'){
        $('#initial_deco').css('display','none');
        $('#initial_simple').css('display','block');
        $('#initial_simple input[name="properties[イニシャルのタイプ]"]').prop('disabled', false);
        $('#initial_alphabet').css('display','block');
        $('#product-option-29').fadeIn();
      } else {
        $('#initial_deco input[name="properties[イニシャルのサイズ]"]').val('');
        $('#initial_deco input[name="properties[イニシャルのサイズ]"]').prop('disabled', true);
        $('#initial_deco span.bold_option_value_element').removeClass('bold_swatch_selected').next('.bold_option_swatch_title').removeClass('bold_option_selected');
        $('#initial_simple input[name="properties[イニシャルのタイプ]"]').val('');
        $('#initial_simple input[name="properties[イニシャルのタイプ]"]').prop('disabled', true);
        $('#initial_simple span.bold_option_value_element').removeClass('bold_swatch_selected').next('.bold_option_swatch_title').removeClass('bold_option_selected');
        $('#product-option-29-005 select').val("");
        $('#initial_deco').css('display','none');
        $('#initial_simple').css('display','none');
        $('#initial_alphabet').css('display','none');
        $('#product-option-29').fadeOut();
      }
    } else if ($('#product-option-30').length) { 
      let sel_variant = document.querySelector("input[name='ポーチサイズ']:checked");
      sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));
      //名入れフォーム表示制御。関係のないオプションは送信しない
      if(sel_variant.value.includes('名入れ')){
        $('#product-option-30-001-input').fadeIn();
      } else {
        $('#product-option-30-001-input').fadeOut();
      }
    } else if ($('#product-option-31').length) { //本のスマホケース（タイトル変更あり、なし）
      let sel_variant = document.querySelector("input[name='タイトルの変更']:checked");
      sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));
      if(sel_variant.value == 'タイトル変更なし'){
        $('#product-option-31').fadeOut();
      } else {
        $('#product-option-31').fadeIn();
      }
    } else {
      //product option idなし
      if(myHandle.includes('exc2od35o')){ //キルティング　リアケース　2つ折りカードケース
        let sel_variant = document.querySelector("input[name='ストラップ']:checked");
        sel_variant_price = Number(sel_variant.dataset.variant_price.replace(/\D/g, ''));
      }
    }

    let total_price;
    if($('#money_price').length) {
      total_price = Number($('#money_price').html().replace(/\D/g, ''));
      if(sel_variant_price > 0){
        total_price = sel_variant_price;
      }
    }else {
      total_price = ProductPrice;
    }

    if ($('#bold_option_total > span').length) {
        total_price = Number($('#bold_option_total > span').text().replace(/\D/g, '')) + total_price;
    }
    //console.log('合計描写 ' + total_price + '/' + ProductPrice + '/' + sel_variant_price);

    // 合計描写
    $('#total_print > span').html('¥' + total_price.toLocaleString());
}

function changeOptionPrice(option_price) {
  // console.log('change option price start = ' + option_price);

  let option_total_price = Number($('#bold_option_total > span').text().replace(/\D/g, ''));
  option_total_price = option_total_price + Number(option_price);

// console.log('option_total_price = ' + option_total_price);

  if (option_total_price > 0) {
    // オプション合計表示
    $('#bold_option_total > span').html('¥' + option_total_price.toLocaleString());
    $('#bold_option_total').removeClass('bold_option_hidden');
  } else {
    // 非表示
    $('#bold_option_total').addClass('bold_option_hidden');
    $('#bold_option_total > span').html('');
  }

  // 合計描写
  changePrice();
}

// 有料オプション商品をカートに追加
function addCartOptionProduct(item) {
  // console.log('add item = '+JSON.stringify(item));
  var result = $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: false,
    data: item,
    dataType: 'json',
  }).responseText;
return result;
}

// 有料オプション商品をカートから削除
function deleteCartOptionProduct(item) {
  // console.log('del item = '+JSON.stringify(item));
  var result = $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    async: false,
    data: item,
    dataType: 'json',
  }).responseText;
return result;
}


function getTextLengthZen2(text){
  var regexp = /[\x01-\x7E\u{FF65}-\u{FF9F}]/mu;

  var len = 0;
  for(i = 0; i < text.length; i++){
      var ch = text[i];
      len += regexp.test(new String(ch)) ? 1 : 2;
  }
  return len;
}


